import { render, staticRenderFns } from "./PointNetridecashTechcoin.vue?vue&type=template&id=6e867e36"
import script from "./PointNetridecashTechcoin.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports